var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 120 120",
    width: "120px",
    height: "120px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface283438003"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(100%,100%,100%)",
      fillOpacity: 1
    },
    d: "M 39.992188 12 C 24.554688 12 12 24.566406 12 40.007812 L 12 80.007812 C 12 95.445312 24.566406 108 40.007812 108 L 80.007812 108 C 95.445312 108 108 95.433594 108 79.992188 L 108 39.992188 C 108 24.554688 95.433594 12 79.992188 12 Z M 88 28 C 90.207031 28 92 29.792969 92 32 C 92 34.207031 90.207031 36 88 36 C 85.792969 36 84 34.207031 84 32 C 84 29.792969 85.792969 28 88 28 Z M 60 36 C 73.234375 36 84 46.765625 84 60 C 84 73.234375 73.234375 84 60 84 C 46.765625 84 36 73.234375 36 60 C 36 46.765625 46.765625 36 60 36 Z M 60 44 C 51.164062 44 44 51.164062 44 60 C 44 68.835938 51.164062 76 60 76 C 68.835938 76 76 68.835938 76 60 C 76 51.164062 68.835938 44 60 44 Z M 60 44 "
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.8b798bf08445de9bbf794390a231a79d.svg";
export { ForwardRef as ReactComponent };